import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqService } from '../services/constructionBoq.service';
import type { ConstructionBoq, BoqFilters } from '../types/construction-boq.types';
import { useState } from 'react';
import { toast } from 'sonner';

export function useConstructionBoqs(companyId: string, initialFilters: BoqFilters = {}) {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState<BoqFilters>({
    status: 'all',
    ...initialFilters
  });

  const query = useQuery({
    queryKey: ['construction-boqs', companyId, filters],
    queryFn: () => ConstructionBoqService.getBoqs(companyId, filters),
    enabled: !!companyId,
  });

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionBoq>) => ConstructionBoqService.createBoq(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs'] });
      toast.success('Khởi tạo BOQ thi công thành công');
    },
  });

  return {
    boqs: query.data?.data || [],
    total: query.data?.total || 0,
    isLoading: query.isLoading,
    filters,
    setFilters,
    createBoq: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
